var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "b-modal",
        {
          attrs: { active: _vm.isFormModalActive },
          on: {
            "update:active": function($event) {
              _vm.isFormModalActive = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "modal-card", staticStyle: { width: "auto" } },
            [
              _c("header", { staticClass: "modal-card-head" }, [
                !_vm.isNew
                  ? _c(
                      "p",
                      { staticClass: "modal-card-title has-text-weight-bold" },
                      [_vm._v(" " + _vm._s(_vm.$t("button.edit")) + " ")]
                    )
                  : _vm._e(),
                _vm.isNew
                  ? _c(
                      "p",
                      { staticClass: "modal-card-title has-text-weight-bold" },
                      [_vm._v(" " + _vm._s(_vm.$t("button.add")) + " ")]
                    )
                  : _vm._e()
              ]),
              _c(
                "section",
                { staticClass: "modal-card-body" },
                [
                  _c(
                    "b-field",
                    {
                      attrs: {
                        label: _vm.$t("label.title"),
                        message: _vm.errors.has("title")
                          ? _vm.$t("messages.field_is_required")
                          : "",
                        type: { "is-danger": _vm.errors.has("title") }
                      }
                    },
                    [
                      _c("b-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: { name: "title" },
                        model: {
                          value: _vm.selected.title,
                          callback: function($$v) {
                            _vm.$set(_vm.selected, "title", $$v)
                          },
                          expression: "selected.title"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    {
                      attrs: {
                        label: _vm.$t("label.url"),
                        message: _vm.errors.has("url")
                          ? _vm.$t("messages.field_is_required")
                          : "",
                        type: { "is-danger": _vm.errors.has("url") }
                      }
                    },
                    [
                      _c("b-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: { name: "url" },
                        model: {
                          value: _vm.selected.url,
                          callback: function($$v) {
                            _vm.$set(_vm.selected, "url", $$v)
                          },
                          expression: "selected.url"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    {
                      attrs: {
                        message: _vm.errors.has("type")
                          ? _vm.$t("messages.field_is_required")
                          : "",
                        type: { "is-danger": _vm.errors.has("type") },
                        label: _vm.$t("label.type")
                      }
                    },
                    [
                      _c(
                        "b-select",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: { name: "type" },
                          model: {
                            value: _vm.selected.type,
                            callback: function($$v) {
                              _vm.$set(_vm.selected, "type", $$v)
                            },
                            expression: "selected.type"
                          }
                        },
                        _vm._l(_vm.newsTypeOptions, function(item, index) {
                          return _c(
                            "option",
                            { key: index, domProps: { value: item.type } },
                            [_vm._v(" " + _vm._s(_vm.$t(item.label)) + " ")]
                          )
                        }),
                        0
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("footer", { staticClass: "modal-card-foot" }, [
                _c(
                  "button",
                  {
                    staticClass: "button has-text-weight-semibold",
                    on: {
                      click: function($event) {
                        _vm.isFormModalActive = false
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("button.cancel")) + " ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "button is-primary has-text-weight-bold",
                    on: {
                      click: function($event) {
                        return _vm.handleApplyChange()
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.buttonSaveText) + " ")]
                )
              ])
            ]
          )
        ]
      ),
      _c("nav", { staticClass: "level" }, [
        _c("div", { staticClass: "level-left" }, [
          _c(
            "div",
            { staticClass: "level-item" },
            [
              _c(
                "b-select",
                {
                  attrs: { disabled: !_vm.isPaginated },
                  model: {
                    value: _vm.perPage,
                    callback: function($$v) {
                      _vm.perPage = $$v
                    },
                    expression: "perPage"
                  }
                },
                [
                  _c("option", { attrs: { value: "5" } }, [_vm._v("5")]),
                  _c("option", { attrs: { value: "10" } }, [_vm._v("10")]),
                  _c("option", { attrs: { value: "20" } }, [_vm._v("20")]),
                  _c("option", { attrs: { value: "50" } }, [_vm._v("50")]),
                  _c("option", { attrs: { value: "100" } }, [_vm._v("100")])
                ]
              ),
              _c("span", { staticClass: "p-l-sm" }, [
                _vm._v(_vm._s(_vm.$t("pagination.per_page")))
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "level-item" },
            [
              _c(
                "b-select",
                {
                  attrs: { disabled: !_vm.isPaginated },
                  model: {
                    value: _vm.currentPage,
                    callback: function($$v) {
                      _vm.currentPage = $$v
                    },
                    expression: "currentPage"
                  }
                },
                _vm._l(_vm.numofPage, function(index) {
                  return _c(
                    "option",
                    { key: index, domProps: { value: index } },
                    [_vm._v(" " + _vm._s(index) + " ")]
                  )
                }),
                0
              ),
              _c("span", { staticClass: "p-l-sm" }, [
                _vm._v(_vm._s(_vm.$t("pagination.of_pages")))
              ])
            ],
            1
          )
        ]),
        _c("div", { staticClass: "level-right" }, [
          _c("div", { staticClass: "level-item" }, [
            _c(
              "div",
              { staticClass: "control" },
              [
                _c(
                  "b-field",
                  [
                    _c(
                      "p",
                      { staticClass: "control" },
                      [
                        _c(
                          "b-dropdown",
                          {
                            model: {
                              value: _vm.selectedFilter,
                              callback: function($$v) {
                                _vm.selectedFilter = $$v
                              },
                              expression: "selectedFilter"
                            }
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "button",
                                attrs: { slot: "trigger" },
                                slot: "trigger"
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.convertFieldName(_vm.selectedFilter)
                                    )
                                  )
                                ]),
                                _c("b-icon", { attrs: { icon: "menu-down" } })
                              ],
                              1
                            ),
                            _c(
                              "b-dropdown-item",
                              { attrs: { value: "title" } },
                              [_vm._v(_vm._s(_vm.$t("label.title")))]
                            ),
                            _c("b-dropdown-item", { attrs: { value: "url" } }, [
                              _vm._v(_vm._s(_vm.$t("label.url")))
                            ]),
                            _c(
                              "b-dropdown-item",
                              { attrs: { value: "type" } },
                              [_vm._v(_vm._s(_vm.$t("label.type")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("b-input", {
                      attrs: {
                        icon: "magnify",
                        type: "search",
                        placeholder: _vm.$t("label.search_placeholder")
                      },
                      model: {
                        value: _vm.searchQuery,
                        callback: function($$v) {
                          _vm.searchQuery = $$v
                        },
                        expression: "searchQuery"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "level-item buttons" }, [
            _vm.canEdit()
              ? _c(
                  "button",
                  {
                    staticClass: "button is-primary",
                    on: {
                      click: function($event) {
                        return _vm.handleOpenModalAdd()
                      }
                    }
                  },
                  [
                    _c("b-icon", { attrs: { icon: "plus" } }),
                    _c("span", [_vm._v(_vm._s(_vm.$t("button.add")))])
                  ],
                  1
                )
              : _vm._e(),
            _c("button", { staticClass: "button" }, [
              _c(
                "span",
                [
                  _c(
                    "download-csv",
                    {
                      attrs: {
                        data: _vm.news,
                        fields: _vm.csvFields,
                        name: "news.csv"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("button.export_csv")))]
                  )
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _c(
        "b-table",
        {
          attrs: {
            data: _vm.isLoading ? [] : _vm.filteredData,
            narrowed: true,
            paginated: _vm.isPaginated,
            "per-page": _vm.perPage,
            striped: true,
            hoverable: true,
            "current-page": _vm.currentPage,
            "pagination-simple": _vm.isPaginationSimple,
            "pagination-position": _vm.paginationPosition,
            "default-sort-direction": _vm.defaultSortDirection,
            "sort-icon-size": _vm.sortIconSize,
            "aria-next-label": "Next page",
            "aria-previous-label": "Previous page",
            "aria-page-label": "Page",
            "aria-current-label": "Current page"
          },
          on: {
            "update:currentPage": function($event) {
              _vm.currentPage = $event
            },
            "update:current-page": function($event) {
              _vm.currentPage = $event
            }
          }
        },
        [
          _vm._t("columns"),
          _c("b-table-column", {
            attrs: {
              field: "title",
              label: _vm.$t("label.title"),
              sortable: ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [_vm._v(_vm._s(props.row.title || "-"))]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: { field: "url", label: _vm.$t("label.url"), sortable: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [_vm._v(_vm._s(props.row.url || "-"))]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: { field: "type", label: _vm.$t("label.type"), sortable: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _vm.isImportant(props.row.type)
                      ? _c(
                          "b-tag",
                          { attrs: { rounded: "", type: "is-danger m-r-md" } },
                          [
                            _vm._v(
                              _vm._s(_vm.newsTypeText(props.row.type) || "-")
                            )
                          ]
                        )
                      : _vm.isInfo(props.row.type)
                      ? _c(
                          "b-tag",
                          { attrs: { rounded: "", type: "is-primary m-r-md" } },
                          [
                            _vm._v(
                              _vm._s(_vm.newsTypeText(props.row.type) || "-")
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: { width: "100", field: "edit", label: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _vm.canEdit()
                      ? _c(
                          "button",
                          {
                            staticClass: "button is-text is-action",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.handleOpenModalEdit(props.row)
                              }
                            }
                          },
                          [
                            _c("b-icon", {
                              attrs: {
                                size: "is-small",
                                icon: "circle-edit-outline"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.canDelete()
                      ? _c(
                          "button",
                          {
                            staticClass: "button is-text is-action",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.handleConfirmCustomDelete(props.row)
                              }
                            }
                          },
                          [
                            _c("b-icon", {
                              attrs: { size: "is-small", icon: "delete" }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          !_vm.isLoading
            ? _c("template", { slot: "empty" }, [_c("NotFound")], 1)
            : _vm._e()
        ],
        2
      ),
      _c("b-loading", {
        attrs: { "is-full-page": true, active: _vm.isLoading },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }